var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.params.value != 0)?_c('div',[_c('i',{staticClass:"fas fa-circle",class:{
    'rejected' : (_vm.params.value > 0 && _vm.params.value < 5) || _vm.params.value == 60,
    'revision': _vm.params.value == 10 || _vm.params.value == 12,
    'reg-approve': _vm.params.value == 16 || _vm.params.value == 18,
    'filled': _vm.params.value == 20,
    'plan-approve': _vm.params.value == 22,
    'finished': _vm.params.value == 50 }}),_vm._v("\n  "+_vm._s(_vm.pdrStatus)+"\n")]):_vm._e()}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1237ea94","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/private/operational/pci/components/AtStatusRenderer.vue
// module id = null
// module chunks = 